import { NAME } from "./constants"

export const s = (state) => state[NAME]
export const activeField = (state) => s(state).activeField
